// extracted by mini-css-extract-plugin
module.exports = {"loading-wrap":"components_loading-wrap__3vXvU"};